// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
   apiKey: "AIzaSyCLBL0VaeR9STHfGb1G8-8AGZC8QIP_soM",
  authDomain: "bilal-ffb25.firebaseapp.com",
  databaseURL: "https://bilal-ffb25-default-rtdb.firebaseio.com",
  projectId: "bilal-ffb25",
  storageBucket: "bilal-ffb25.firebasestorage.app",
  messagingSenderId: "349354566971",
  appId: "1:349354566971:web:be8afdf7504fec9ecf431e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
